import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { getApiUrl } from '../utils/api';

const Footer = () => {
  const [businessInfo, setBusinessInfo] = useState(null);

  // Fetch business info from backend
  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const apiUrl = getApiUrl();
        const response = await fetch(`${apiUrl}/api/business-info`);
        const data = await response.json();
        setBusinessInfo(data);
      } catch (error) {
        console.error('Error fetching business info:', error);
      }
    };
    
    fetchBusinessInfo();
  }, []);

  // Static location data for footer
  const locations = [
    {
      name: 'Baldwin',
      hours: 'Wednesday - Saturday: 11:00 AM - 10:00 PM',
    },
    {
      name: 'Home Studio Islandia',
      hours: 'Monday & Tuesday: 5:00 PM - 10:00 PM',
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">{businessInfo?.name || 'The Slay Station'}</h3>
            <p className="footer-tagline">{businessInfo?.tagline || 'Luxury Esthetics & Beauty'}</p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/favorites">Shop With Me</Link></li>
              <li><Link to="/booking">Book Now</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-contact">
              <a href={`tel:${businessInfo?.phone || '(631) 772-9261'}`} className="footer-contact-item">
                <Phone size={16} />
                <span>{businessInfo?.phone || '(631) 772-9261'}</span>
              </a>
              <a href={`mailto:${businessInfo?.email || 'Apolonia@glamouroverall.com'}`} className="footer-contact-item">
                <Mail size={16} />
                <span>{businessInfo?.email || 'Apolonia@glamouroverall.com'}</span>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Locations</h4>
            <div className="footer-locations">
              {locations.map((location, index) => (
                <div key={index} className="footer-location">
                  <p className="footer-location-name">{location.name}</p>
                  <p className="footer-location-hours">{location.hours}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} {businessInfo?.name || 'The Slay Station'}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
